module.exports = __webpack_public_path__ + "static/media/default-tournament-bg-th.8a4b0cbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tournaments/images/default-tournament-bg-th.jpg
// module id = 412
// module chunks = 103